import {
    Injector,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { BaseChart } from '@components/ui-chart/base-chart';
import { ChartLineStyle } from '@components/ui-chart/base-chart.types';

import { takeUntil } from 'rxjs/operators';

import {
    AXES_CHART_OPTIONS_MAPPER,
    COMMON_AXES_OPTIONS,
    mapBaseAxesColorOptions,
} from './base-axes-chart.constants';

export abstract class BaseAxesChart<T>
    extends BaseChart<T>
    implements OnChanges {

    @Input()
    public xAxisLabels?: Array<string>;

    @Input()
    public xAxisLabelsRotation = 0;

    @Input()
    public showXAxisTickLines = true;

    @Input()
    public yAxisTickLineStyle = ChartLineStyle.Solid;

    @Input()
    public showGridBorder = true;

    @Input()
    public showAxes = true;

    @Input()
    public showLegend = true;

    constructor(protected _injector: Injector) {
        super(_injector);
        this._extendOptions(COMMON_AXES_OPTIONS);
        this._colorProvider.changes$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(() => {
                this._extendOptions(mapBaseAxesColorOptions(this._colorProvider));
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        this._mapOptions(AXES_CHART_OPTIONS_MAPPER, changes);
    }
}
